import { PAYMENT_TYPES } from '~/const/payments';
export var CREDIT_ELIGIBLE_PAYMENT_TYPE = [[PAYMENT_TYPES.AVOIR], [PAYMENT_TYPES.CKDO], [PAYMENT_TYPES.BA]];
export var REFUND_ELIGIBLE_PAYMENT_TYPE = [];